/*
 * View for deleting mulitple quick create topics at once.  This is similar to the topicsControlsView.js
 */

define([
  "marionette",
  "modules/quickCreate/quickCreateControls/template/quickCreateControlsTemplate.html",
], function (Marionette, QuickCreateControlsTemplate) {
  var QuickCreateControlsView = {};

  QuickCreateControlsView.quickCreateControlsView = Marionette.ItemView.extend({
    template: QuickCreateControlsTemplate,
    clearError: function () {
      this.$el.find("#controlsError").html("");
    },
    controlsError: function (errorMessage) {
      this.$el
        .find("#controlsError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    triggers: {
      "click #deleteTopics": "delete:topics",
    },
  });

  return QuickCreateControlsView;
});
